/**
 @ngdoc service
 @name mapManagerTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapManagerTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            tileFactory.addFieldToColumn1(tileFactory.field.newField('id'));
            tileFactory.addFieldToColumn1(
                tileFactory.field.newInactiveFieldAjax('mobile', 'unsubscribedFromCalls', 'unsubscribedFromCalls', 'actionLogURI','logPhoneCall'));
            tileFactory.addFieldToColumn1(
                tileFactory.field.newRankedInactiveFieldAjax(
                    'telephone',
                    [['ctpsBarring', 'ctpsBarring'], ['unsubscribedFromCalls', 'unsubscribedFromCalls']],
                    'actionLogURI','logPhoneCallTelephone'
                )
            );

            tileFactory.addStatus(tileFactory.status.newFinancialActivtyStatus('finActivityFlag','finTabURI'));
            // tileFactory.addFieldToColumn1(tileFactory.field.newField('email'));
            tileFactory.addFieldToFullWidthRow(tileFactory.field.newInactiveWarningField('email', ['invalidEmailWarning', 'spamEmailWarning'], 'unsubscribedFromEmails', 'unsubscribedFromEmails', 'actionLogURI'));
            tileFactory.addFieldToColumn2(tileFactory.field.newMultipleAddressField('town'));
            tileFactory.addFieldToColumn2(tileFactory.field.newMultipleFieldWithLink('businessName', 'businessURI'));
            tileFactory.addFieldToColumn3(tileFactory.field.newMultipleField('jobTitle'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('department'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('lastContact', 'dateTime'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('title'));

            // Adding status to tile data

            // 5081: "Prospective"
            // 5082: "Active"
            // 5084: "Dormant"
            // 5085: "Stopped"
            // 5086: "Left"
            // 5120: "Lapsed"
            tileFactory.addStatus(tileFactory.status.newStatusWithInfoAndStyling('managerStatus', 'statusHelpText', [tileFactory.LOOKUP_VALUE.MANAGER_STATUS_BOOKING],[], [tileFactory.LOOKUP_VALUE.MANAGER_STATUS_JOB]));

            tileFactory.addStatus(tileFactory.status.newFrameworkStatus('frameworkNameHoverText'));
            tileFactory.addStatus(tileFactory.status.newStatusWithState('noSaleContact', 'danger'));
            tileFactory.addStatus(tileFactory.status.newStatusWithState('secondaryStatusLeft', 'danger'));
            if(rawTileData.emailPermission==true) {
                tileFactory.addStatus(tileFactory.status.newLabelStatus('invalidEmailStatus', 'invalidEmailWarning'));
                tileFactory.addStatus(tileFactory.status.newLabelStatus('invalidSpamStatus', 'spamEmailWarning'));
            }
            tileFactory.addStatus(tileFactory.status.newLabelStatusWithClass('focusManager', 'focusManagerHelpText','focusManagerClass'));

            var callToHistoryModel = tileFactory.callToAction.newCallToActionModal('recentHistory', 'recentHistory');
            tileFactory.addCallToAction(callToHistoryModel);

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapManagerTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapManagerTileService', mapManagerTileService);
}());
